import { observer } from "mobx-react-lite";
import React from "react";
import { Outlet } from "react-router";

import { useApp } from "../context";

import { AdminHomeLayout } from "./AdminHomeLayout";
import { ErrorMessage } from "./ErrorMessage";

export const AdminHomeRoute = observer(function AdminHomeRoute({ children }) {
  const app = useApp();

  // TODO: Check auth/permission

  React.useEffect(() => {
    app.admin.init();
  }, []);

  if (!app.parse.user?.isAdmin) {
    return (
      <ErrorMessage
        icon="fa:exclamation-circle"
        title="Berechtigungs Fehler"
        message="Du musst Admin Nutzer sein, um diese Seite zu sehen."
      />
    );
  }

  return (
    <AdminHomeLayout>
      <Outlet />
    </AdminHomeLayout>
  );
});
